import React from 'react';
import { Button } from '@components/ui/button';

export const PREVIEW_COUNT = 5;

interface ListHeadingProps {
    label: string;
    count: number;
    children?: React.ReactNode;
}

export const ListHeading = ({ label, count, children }: ListHeadingProps) => (
    <div className="flex items-baseline gap-2 border-b border-border pb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        <span>{label}</span>
        <span className="font-normal tabular-nums">{count}</span>
        {children}
    </div>
);

interface ShowAllButtonProps {
    total: number;
    expanded: boolean;
    onToggle(): void;
}

export const ShowAllButton = ({ total, expanded, onToggle }: ShowAllButtonProps) =>
    total > PREVIEW_COUNT ? (
        <Button variant="link" size="sm" className="mt-2 self-start px-0" onClick={onToggle}>
            {expanded ? `Show first ${PREVIEW_COUNT}` : `Show all (${total})`}
        </Button>
    ) : null;
